<template>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="mb-2">
            <h5>
              <b-button class="mr-2" v-if="permission.edit" variant="outline-primary" :to="{ name: 'FormEdit', params: { id: item.id, model: 'ugroup' }}">Edit</b-button>
              {{item.name}}
            </h5>
          </div>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import ac from '@/libs/accesscontrol'

export default {
  name: 'UgroupSimple',
  props: ['item', 'username'],
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: async function () {
    this.permission.edit = ac.can(this.user.acgroups).updateAny('ugroup').granted
  },
  data () {
    return {
      permission: {
        edit: false
      }
    }
  }
}
</script>

<style>
</style>
